import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userStr = localStorage.getItem("user");

  if (!userStr) {
    // If no user found, kick them back to login
    return <Navigate to="/login" replace />;
  }

  try {
    const userObj = JSON.parse(userStr);
    if (userObj && userObj.exp) {
      const currentTime = Date.now() / 1000;
      if (userObj.exp < currentTime) {
        console.warn("Session expired. Redirecting to login.");
        localStorage.removeItem("user");
        localStorage.removeItem("userMobile");
        return <Navigate to="/login" replace />;
      }
    }
  } catch (e) {
    console.error("Invalid user session. Redirecting to login.", e);
    localStorage.removeItem("user");
    localStorage.removeItem("userMobile");
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
